import React from "react";
import FridgePageTemplate from "./FridgePageTemplate";

const relatedLinks = [
  { to: "/fridge-service-bangalore", label: "Refrigerator Service" },
  { to: "/double-door-refrigerator-service-bangalore", label: "Double Door Service" },
  { to: "/side-by-side-fridge-service-bangalore", label: "Side-by-Side Service" },
  { to: "/fridge-compressor-repair", label: "Compressor Repair" },
  { to: "/fridge-noise-problem", label: "Noise Problem" },
];

const FridgeNotCoolingRepair = () => {
  return (
    <FridgePageTemplate
      title="Fridge Not Cooling Repair in Bangalore"
      description="Professional refrigerator not cooling repair in Bangalore for temperature, compressor, and airflow issues."
      keywords="fridge not cooling repair bangalore, refrigerator cooling service, fridge temperature problem"
      path="/fridge-not-cooling-repair"
      bannerTitle="Fridge Not Cooling Repair"
      intro={
        <>
          If your <span style={{ fontWeight: "bold" }}>fridge is not cooling properly</span>, our Bangalore technicians inspect the compressor, evaporator, thermostat, and gas circuits to restore cold performance.
        </>
      }
      highlights={[
        "Temperature drop and cooling diagnostics",
        "Compressor and condenser repair",
        "Evaporator and refrigerant checks",
        "Door seal and airflow troubleshooting",
      ]}
      issues={[
        "Fridge warm inside",
        "Freezer not freezing",
        "Uneven cooling across shelves",
        "Compressor runs constantly",
      ]}
      relatedLinks={relatedLinks}
    />
  );
};

export default FridgeNotCoolingRepair;

